export const bond_renewal = [
	{ label: 'Monthly', value: 'MONTHLY' },
	{ label: 'Quarterly', value: 'QUARTERLY' },
	{ label: 'Annually', value: 'ANNUALLY' },
];
